export const FQF_TIME_UNITS = {
  seconds: 'seconds',
  minutes: 'minutes',
  hours: 'hours',
  days: 'days',
  weeks: 'weeks'
};
export const ILS_FILTER_TIME_UNITS = {
  seconds: 'seconds',
  minutes: 'minutes',
  hours: 'hours',
  days: 'days'
};
export const CRM_FILTER_TIME_UNITS = {
  SECOND: 'SECOND',
  MINUTE: 'MINUTE',
  HOUR: 'HOUR',
  DAY: 'DAY'
};
export const getDefaultUnit = duration => {
  if (duration % (24 * 60 * 60 * 1000) === 0) {
    return FQF_TIME_UNITS.days;
  }
  if (duration % (60 * 60 * 1000) === 0) {
    return FQF_TIME_UNITS.hours;
  }
  if (duration % (60 * 1000) === 0) {
    return FQF_TIME_UNITS.minutes;
  }
  return FQF_TIME_UNITS.seconds;
};
export const getUnitForCrmRelativeTimePropertyFilter = duration => {
  if (duration % (24 * 60 * 60 * 1000) === 0) {
    return CRM_FILTER_TIME_UNITS.DAY;
  }
  if (duration % (60 * 60 * 1000) === 0) {
    return CRM_FILTER_TIME_UNITS.HOUR;
  }
  if (duration % (60 * 1000) === 0) {
    return CRM_FILTER_TIME_UNITS.MINUTE;
  }
  return CRM_FILTER_TIME_UNITS.SECOND;
};
export const formatDurationToUnit = (duration, unit) => {
  if (duration === undefined) {
    return undefined;
  }
  switch (unit) {
    case ILS_FILTER_TIME_UNITS.days:
    case CRM_FILTER_TIME_UNITS.DAY:
      return duration / 1000 / 60 / 60 / 24;
    case ILS_FILTER_TIME_UNITS.hours:
    case CRM_FILTER_TIME_UNITS.HOUR:
      return duration / 1000 / 60 / 60;
    case ILS_FILTER_TIME_UNITS.minutes:
    case CRM_FILTER_TIME_UNITS.MINUTE:
      return duration / 1000 / 60;
    case ILS_FILTER_TIME_UNITS.seconds:
    case CRM_FILTER_TIME_UNITS.SECOND:
    default:
      return duration / 1000;
  }
};
export const formatDurationToMilliseconds = (duration, unit) => {
  switch (unit) {
    case ILS_FILTER_TIME_UNITS.days:
    case CRM_FILTER_TIME_UNITS.DAY:
      return duration * 1000 * 60 * 60 * 24;
    case ILS_FILTER_TIME_UNITS.hours:
    case CRM_FILTER_TIME_UNITS.HOUR:
      return duration * 1000 * 60 * 60;
    case ILS_FILTER_TIME_UNITS.minutes:
    case CRM_FILTER_TIME_UNITS.MINUTE:
      return duration * 1000 * 60;
    case ILS_FILTER_TIME_UNITS.seconds:
    case CRM_FILTER_TIME_UNITS.SECOND:
    default:
      return duration * 1000;
  }
};
export const formatDurationFromMillisecondsToTimepoint = duration => {
  if (Number.isNaN(duration)) {
    return undefined;
  }
  const totalSeconds = Math.floor(Math.abs(duration) / 1000);
  const seconds = totalSeconds % 60;
  const totalMinutes = Math.floor(totalSeconds / 60);
  const minutes = totalMinutes % 60;
  const totalHours = Math.floor(totalMinutes / 60);
  const hours = totalHours % 24;
  const days = Math.floor(totalHours / 24);
  const isNegativelySigned = duration < 0;
  return isNegativelySigned ? {
    days: -days,
    hours: -hours,
    minutes: -minutes,
    seconds: -seconds
  } : {
    days,
    hours,
    minutes,
    seconds
  };
};
export const formatDurationFromTimepointToMilliseconds = timepoint => {
  const {
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0
  } = timepoint;
  const millisecondsPerMinute = 60 * 1000;
  const millisecondsPerHour = 60 * millisecondsPerMinute;
  const millisecondsPerDay = 24 * millisecondsPerHour;
  const totalMilliseconds = days * millisecondsPerDay + hours * millisecondsPerHour + minutes * millisecondsPerMinute + seconds * 1000;
  return totalMilliseconds;
};